<div class="container-list-page">
  <form [formGroup]="containerListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <h4 class="page-title">Container</h4>
          @if (addPermission) {
            <a class="__add_client" (click)="openContainerForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Container
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <table mat-table matSort [dataSource]="containerDataSource" (matSortChange)="sortData($event)">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>Container Name</span>
                  <input placeholder="Search by Container Name" type="search" matInput
                    autocomplete="off" formControlName="name" class="mat-input-custom">
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">{{element.name}}</td>
              </ng-container>
              <ng-container matColumnDef="size">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Container Size</span>
                    <mat-select formControlName="size" placeholder="Search by Size">
                      <mat-option [value]="null">None</mat-option>
                      @for (size of equipmentSizes; track size) {
                        <mat-option [value]="size">
                          {{size}}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">{{element.size}}</td>
              </ng-container>
              <ng-container matColumnDef="equipmentType.name">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Equipment</span>
                    <input placeholder="Search by Equipment Type" type="search" matInput
                      autocomplete="off" formControlName="equipment" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.type}}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Status</span>
                      <mat-select formControlName="status" placeholder="Search by Status">
                        @for (status of statusTypes; track status) {
                          <mat-option [value]="status.key">
                            {{status.label}}
                          </mat-option>
                        }
                      </mat-select>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.status}}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    <span class="mat-sort-header-content" >Action</span></th>
                    <td class="__action_row" mat-cell *matCellDef="let element">
                      @if (editPermission) {
                        <span class="__action_edit_icon" (click)="openContainerForm(element.id)">
                          <mat-icon>create</mat-icon>
                        </span>
                      }
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="containerColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: containerColumns;"></tr>
                </table>
              }
            </mat-card-content>
          </mat-card>
          @if (viewPermission) {
            <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalRecords" showFirstLastButtons></mat-paginator>
          }
        </form>
      </div>



